import React from "react";

const PageTitle = ({ title }) => (
  <div className="text-center">
    <h1 className="relative inline-block px-5 py-2 text-3xl md:text-4xl xl:text-5xl font-bold bg-white border-2 border-black">
      <div className="absolute w-full py-2 h-full inset-0 border-2 border-black bg-black ml-1.5 mt-1.5"></div>
      <div className="absolute inset-0 w-full h-full py-2 bg-white"></div>
      <span className="relative">{title}</span>
    </h1>
  </div>
);
export default PageTitle;
